import cn from 'classnames'
import { Typography, TYPOGRAPHY_WEIGHT } from 'components/Typography'
import {
  DOCUMENT_REQUIRED_ACTION_NAME,
  DOCUMENT_REQUIRED_ACTION_TO_CLASSNAME
} from './constants'
import { TDocumentStatusProps } from './status.document.d'
import './status.document.scss'

export const Document = ({ status }: TDocumentStatusProps) => (
  <Typography.Caption
    className={cn(
      'document-status',
      DOCUMENT_REQUIRED_ACTION_TO_CLASSNAME[status]
    )}
    weight={TYPOGRAPHY_WEIGHT.SEMI_BOLD}
  >
    {DOCUMENT_REQUIRED_ACTION_NAME[status]}
  </Typography.Caption>
)
